import React from "react"
import { AuthorizationsComponent } from "../../components/authorizations"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"

export const AuthorizationsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <AuthorizationsComponent />
    </DefaultPageComp>
  </>
}